import { setup } from 'bem-cn';

const BEM = setup({
  mod: '--',
});

export default BEM;
